import React, {useState} from 'react';


const ForecastForm = ({setNsnData}) => {
    //create state
    const [nsn, setNsn] = useState('')
    const [error, setError] = useState('')

    var niin = nsn.slice(4)
    const handleSubmit = async (e) =>{
        e.preventDefault()

        //get contract history
        const nsnurl = 'https://postgres-nsn-search-tau.vercel.app/api/forecast/' + niin;

        const forcastResponse = await fetch(nsnurl, {
            method:'GET'
        })
        const data = await forcastResponse.json()
        console.log(data)
        if(!forcastResponse.ok){
            setError(data.error)
            console.log(error)
        }else{
            setNsn('')
            setNsnData([data])
            setError(null)
            
            
        }
    }

    return (
    <form className="search" onSubmit={handleSubmit}>
        <h3>Search for a NSN</h3>
        <input
            type="number"
            name="nsnInput"
            onChange={(e) => setNsn(e.target.value)}
            value={nsn}
        />

        <button>Enter</button>
        
    </form>
   
   
  )
}

export default ForecastForm;